import { Platform } from "react-native";

export const PLAY_STORE_PACKAGE = "com.selisegroup.club";
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE}`;
export const PLAY_BANNER_DISMISSED_KEY = "selise-club:play-banner-dismissed";

/** Android phones/tablets only. iOS, iPadOS and desktop browsers never match. */
export const isAndroidUserAgent = (ua: string | undefined | null): boolean =>
  !!ua && /\bAndroid\b/i.test(ua) && !/Windows Phone/i.test(ua);

export const isAndroidWeb = (): boolean =>
  Platform.OS === "web" &&
  typeof navigator !== "undefined" &&
  isAndroidUserAgent(navigator.userAgent);

const storage = (): Storage | null => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
};

export const isPlayBannerDismissed = (): boolean =>
  storage()?.getItem(PLAY_BANNER_DISMISSED_KEY) === "1";

export const dismissPlayBanner = (): void => {
  try {
    storage()?.setItem(PLAY_BANNER_DISMISSED_KEY, "1");
  } catch {
    // private mode / quota: the banner just comes back next visit
  }
};
